export default __webpack_public_path__ + "images/7cef22163416b552f8bf459d0816bea2.svg";